/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import { ComponentChildren, createContext, h, VNode } from "preact";
import { useContext } from "preact/hooks";
import { useNotificationHandler } from "../hooks/useNotifications.js";

type Notif = ReturnType<typeof useNotificationHandler>;
type Type = Notif;
function unhandled(): never {
  throw Error(
    "Missing NotificationProvider. The application is not properly configured.",
  );
}

const initial: Type = {
  notification: [],
  showError: unhandled,
  displayInfo: unhandled,
  showSuccess: unhandled,
  displayError: unhandled,
  clear: unhandled,
  clearErrors: unhandled,
};
const Context = createContext<Type>(initial);

interface Props {
  children: ComponentChildren;
}

// Outmost UI wrapper.
export const NotificationProvider = ({ children }: Props): VNode => {
  const { notification, ...nf } = useNotificationHandler();
  return h(Context.Provider, {
    value: {
      ...nf,
      notification,
    },
    children,
  });
};

export const useNotificationContext = (): Type => useContext(Context);
